/*@ngInject*/
const AdminFunctionHeaderButtonsRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.getAvailableAdminFunctions = function (userId) {
        const url = '/rest/AdminFunction/availableAdminFunctions';

        return this.get(url);
    };
};

angular.module('gw-um-header')
    .service('adminFunctionHeaderButtonsRepository', AdminFunctionHeaderButtonsRepository);
